import Link from 'next/link';
import {
  AnchorHTMLAttributes,
  DetailedHTMLProps,
  PropsWithChildren,
} from 'react';
import { UrlObject } from 'url';

const WrapperLink = ({
  anchorProps,
  href,
  children,
}: PropsWithChildren<{
  href: UrlObject | string | undefined;
  anchorProps?: Omit<
    DetailedHTMLProps<
      AnchorHTMLAttributes<HTMLAnchorElement>,
      HTMLAnchorElement
    >,
    'href'
  >;
}>) => {
  return href === undefined ? (
    <a>{children}</a>
  ) : (
    <Link href={href} passHref scroll={false}>
      <a {...anchorProps}>{children}</a>
    </Link>
  );
};

export default WrapperLink;
